// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"7825394f7bfb7a6889dc","691":"89dfbd1ccf5aa4ff84f2"}[chunkId] + ".js";
};